<app-base-modal
  [title]="noteFilesResourceParams.name"
  [showStateToggle]="true"
>
  @if (isLoading) {
    <app-loader/>
  }
  <div class="container">
    @for (file of noteFilesStateService.noteFilesState(); track $index) {
      <app-file-card
        [fileCard]="{
          id: file.id,
          fileParams: file.file,
          fileType: NOTES_FILE_TYPES,
          isEditModeActive: this.isEditModeActive,
          shouldCheckImageType: true
        }"
        [isNeedArrow]="previewFileUrlsStateService.previewFileUrlsState()[NOTES_FILE_TYPES].length > 1"
        [isNeedPreview]="true"
        (handleDelete)="handleDelete($event, file)"
      />
    }
    <app-file-upload-card
      [fileUploadParams]="{
        parentId: noteFilesDialogData.noteId,
        recordId: noteFilesDialogData.noteId,
        type: NOTES_FILE_TYPES,
        entityFileType: 'NOTE'
      }"
      [isEditModeActive]="isEditModeActive"
      [isNeedPreview]="true"
      (attachFile)="attachFile($event)"
    />
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
